/**
 * html 处理类
 * @class UtilHtml
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsUtil.html.encodeHtml('a>b&&c<d');
 */
class UtilHtml {
  /**
   * 编码HTML
   * @param {String} str string
   * @returns {String} 字符串
   * @method
   */
  encodeHtml(str) {
    return `${str}`
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\x60/g, '&#96;')
      .replace(/\x27/g, '&#39;')
      .replace(/\x22/g, '&quot;');
  }
}

export default new UtilHtml();
